import React from "react";
import VlogList from "../VlogList/VlogList";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const VlogListAllVlogs = () => {
  const title = "וולוגים";

  const description = `ברוכים הבאים למאגר הוולוגים שלי! כאן תמצאו תכנים מעמיקים וממוקדים, שנוצרו במיוחד כדי לשפר את ההבנה שלכם בנושאים טכניים שונים מעולם התכנות. הוולוגים שלי נועדו להציע תובנות ברורות וטיפים שימושיים, שיעזרו לכם להתגבר על אתגרי פיתוח יומיומיים ולהעמיק את הידע שלכם.
  כל וולוג מיועד להעביר ידע מעשי וברור, עם דגש על נושאים שנוגעים ישירות לעבודה היומיומית של מתכנתים. לא משנה אם אתם בתחילת הדרך או עם שנים של ניסיון – תמיד תמצאו כאן משהו חדש ומעניין.`;

  const vlogs = [
    {
      topic: "Computer Science Fundamentals",
      vlogs: [
        {
          id: "Vlogs/ComputerScienceFundamentals/HowComputerThinks",
          name: "איך מחשב חושב?",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/ProgrammingLanguagesIntro",
          name: "מבוא לשפות תכנות",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/HowInternetWorks",
          name: "איך עובד האינטרנט?",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/WhatIsAlgorithm",
          name: "מה זה אלגוריתם?",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/ComputerArchitectureBasics",
          name: "מבנה מחשב – מאיפה הכל מתחיל?",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/SoftwareArchitectureBasics",
          name: "מבנה תוכנה – איך מפתחים באמת?",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/ProgrammingWorldBasics",
          name: "איך בנוי עולם התכנות?",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/CompilationVsInterpretation",
          name: "קומפילציה מול אינטרפרטציה",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/MemoryRAMvsDisk",
          name: "זיכרון במחשב – RAM מול דיסק",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/CloudIntro",
          name: "ענן – מה זה בכלל?",
        },
        {
          id: "Vlogs/ComputerScienceFundamentals/LearningProgramming",
          name: "איך ללמוד נכון תכנות",
        },
      ],
    },
    {
      topic: ".NET",
      vlogs: [
        { id: "Vlogs/NET/CompilingInNET", name: "קומפילציה ב-.NET" },
        {
          id: "Vlogs/NET/DotnetBehind",
          name: "איך .NET עובד מאחורי הקלעים?",
        },
      ],
    },
    {
      topic: "LINQ And IEnumerable",
      vlogs: [
        {
          id: "Vlogs/LINQAndIEnumerable/IEnumerableVsIQueryable",
          name: "IEnumerable לעומת IQueryable",
        },
      ],
    },
    {
      topic: "Software architecture",
      vlogs: [
        {
          id: "Vlogs/Software architecture/WhatIsSoftwareArchitecture",
          name: "מה זה בעצם מבנה תוכנה?",
        },
        {
          id: "Vlogs/Software architecture/SoCCohesionCoupling",
          name: "SoC, Cohesion, Coupling",
        },
        {
          id: "Vlogs/Software architecture/WhatIsLayeredArchitecture",
          name: "מה זה Layered Architecture?",
        },
        {
          id: "Vlogs/Software architecture/WhatIsSOA",
          name: "מה זה בעצם SOA?",
        },
        {
          id: "Vlogs/Software architecture/WhatIsDomainDrivenDesign",
          name: "מה זה בעצם Domain Driven Design?",
        },
        {
          id: "Vlogs/Software architecture/ArchitecturalDecisionRecords",
          name: "מה זה בעצם Architectural Decision Records?",
        },
        {
          id: "Vlogs/Software architecture/EventDrivenArchitecture",
          name: "מה זה בעצם Event Driven Architecture?",
        },
      ],
    },
    {
      topic: "Time and Space Complexity",
      vlogs: [
        {
          id: "Vlogs/TimeAndSpaceComplexity/WhatIsTimeComplexity",
          name: "מה זה סיבוכיות זמן?",
        },
        {
          id: "Vlogs/TimeAndSpaceComplexity/WhatIsSpaceComplexity",
          name: "מה זה סיבוכיות מקום?",
        },
        {
          id: "Vlogs/TimeAndSpaceComplexity/ComplexityAlgorithms",
          name: "סיבוכיות באלגוריתמים נפוצים",
        },
        {
          id: "Vlogs/TimeAndSpaceComplexity/ComplexityDynamicDataStructures",
          name: "סיבוכיות במבני נתונים דינמיים",
        },
        {
          id: "Vlogs/TimeAndSpaceComplexity/CombiningTimeAndSpaceComplexity",
          name: "שילוב סיבוכיות זמן ומקום",
        },
      ],
    },
    {
      topic: "SOLID",
      vlogs: [
        {
          id: "Vlogs/SOLID/SOLIDPrinciples",
          name: "מה זה בעצם SOLID?",
        },
      ],
    },
    {
      topic: "Dependency Injection",
      vlogs: [
        {
          id: "Vlogs/DependencyInjection/WhatIsDependencyInjection",
          name: "מה זה בעצם Dependency Injection?",
        },
      ],
    },
    {
      topic: "CQRS",
      vlogs: [{ id: "Vlogs/CQRS/CQRSWhatIsIt", name: "מה זה בעצם CQRS?" }],
    },
    {
      topic: "Event Sourcing",
      vlogs: [
        {
          id: "Vlogs/Event Sourcing/WhatIsItEventSourcing",
          name: "מה זה בעצם Event Sourcing?",
        },
        {
          id: "Vlogs/Event Sourcing/WhatIsKafkaRedis",
          name: "מה זה בעצם קאפקה ורדיס?",
        },
        {
          id: "Vlogs/Event Sourcing/StreamProcessing",
          name: "מה זה בעצם Stream Processing?",
        },
      ],
    },
    {
      topic: "API",
      vlogs: [
        {
          id: "Vlogs/API/APIDesign",
          name: "קצת על בניית API",
        },
      ],
    },
    {
      topic: "CICD",
      vlogs: [
        {
          id: "Vlogs/CICD/WhatIsCICD",
          name: "מה זה בעצם CICD?",
        },
      ],
    },
    {
      topic: "Scalability",
      vlogs: [
        {
          id: "Vlogs/Scalability/WhatIsScalability",
          name: "מה זה בעצם Scalability?",
        },
        {
          id: "Vlogs/Scalability/HorizontalvsVerticalScaling",
          name: "Horizontal vs. Vertical Scaling",
        },
      ],
    },
    {
      topic: "SignalR",
      vlogs: [
        {
          id: "Vlogs/SignalR/HowSignalRworks",
          name: "איך עובד SignalR?",
        },
        {
          id: "Vlogs/SignalR/RealTimeAndSignalR",
          name: "מה זה בעצם ריל-טיים ומה זה בעצם SignalR?",
        },
        {
          id: "Vlogs/SignalR/SignalRServerClient",
          name: "SignalR משנה את השיח בין שרת ללקוח",
        },
        {
          id: "Vlogs/SignalR/SignalRMakesAppsAlive",
          name: 'איך SignalR הופך אפליקציות ל"חיות"',
        },
        {
          id: "Vlogs/SignalR/SignalRAdvancedProductionTips",
          name: "טיפים מתקדמים ל-SignalR בפרודקשן",
        },
      ],
    },
    {
      topic: "Async Programming",
      vlogs: [
        {
          id: "Vlogs/AsyncProgramming/WhatIsAsyncProgramming",
          name: "מה זה בעצם Async Programming?",
        },
      ],
    },
    {
      topic: "Security",
      vlogs: [
        {
          id: "Vlogs/Security/SecurityDesignPrinciples",
          name: "עקרונות בטיחות בעיצוב תוכנה",
        },
      ],
    },
    {
      topic: "Microservices",
      vlogs: [
        {
          id: "Vlogs/Microservices/ManageServicesProperly",
          name: "איך לנהל שירותים נכון?",
        },
        {
          id: "Vlogs/Microservices/WhatIsAPIGateway",
          name: "מה זה בעצם API Gateway?",
        },
        {
          id: "Vlogs/Microservices/DatabasePerService",
          name: "Database per Service – עצמאות נתונים במיקרו-שירותים",
        },
        {
          id: "Vlogs/Microservices/EventSourcing",
          name: "Event Sourcing – כשההיסטוריה הופכת למקור האמת",
        },
        {
          id: "Vlogs/Microservices/SagaPattern",
          name: "Saga Pattern – ניהול טרנזקציות מורכבות במערכות מפוזרות",
        },
        {
          id: "Vlogs/Microservices/CircuitBreaker",
          name: "Circuit Breaker Pattern – מגן חכם למערכות מפוזרות",
        },
        {
          id: "Vlogs/Microservices/StranglerFigPattern",
          name: "Strangler Fig Pattern – מיגרציה הדרגתית של מערכות Legacy",
        },
        {
          id: "Vlogs/Microservices/CQRS",
          name: "CQRS – הפרדה חכמה בין קריאה וכתיבה",
        },
      ],
    },
    {
      topic: "Databases",
      vlogs: [
        {
          id: "Vlogs/Databases/DatabaseEvolution",
          name: "האבולוציה של מסדי הנתונים",
        },
        {
          id: "Vlogs/Databases/IndexesAndQueryOptimization",
          name: "אינדקסים ואופטימיזציה של שאילתות",
        },
        {
          id: "Vlogs/Databases/TransactionsAndLocking",
          name: "דינמיקה של טרנזקציות וניהול נעילות",
        },
      ],
    },
  ];

  return (
    <>
      <VlogList title={title} description={description} vlogs={vlogs} />
    </>
  );
};

export default VlogListAllVlogs;
